"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InjectRouteContext = InjectRouteContext;
exports.useRouteContext = exports.RouteContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _addLanguagePrefixToUrl = _interopRequireDefault(require("@deosite/helpers/addLanguagePrefixToUrl"));
var _addLanguageSufixToRouteName = _interopRequireDefault(require("@deosite/helpers/addLanguageSufixToRouteName"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var RouteContext = /*#__PURE__*/(0, _react.createContext)();
exports.RouteContext = RouteContext;
function InjectRouteContext(props) {
  var result = (0, _react.useRef)(props.getUrl);
  var propsMemorized = (0, _react.useMemo)(function () {
    return {
      Link: props.Link,
      Router: props.Router,
      addLanguagePrefixToUrl: (0, _addLanguagePrefixToUrl["default"])(props.languagePrefix),
      addLanguageSufixToRouteName: (0, _addLanguageSufixToRouteName["default"])(props.languagePrefix)
    };
  }, [result.current]);
  return __jsx(RouteContext.Provider, {
    value: propsMemorized
  }, props.children);
}
var useRouteContext = function useRouteContext() {
  return (0, _react.useContext)(RouteContext);
};
exports.useRouteContext = useRouteContext;